import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "text-sm font-medium" }
const _hoisted_3 = ["id"]

import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { Capacitor } from '@capacitor/core';
import { BannerAdPosition } from '@capacitor-community/admob';
import { admobService } from '../services/admobService';
import { useConsentStore } from '../stores/consentStore';

interface Props {
  adType: 'banner' | 'rectangle';
  position?: BannerAdPosition;
  minHeight?: string;
  class?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileAd',
  props: {
    adType: {},
    position: { default: BannerAdPosition.BOTTOM_CENTER },
    minHeight: { default: '90px' },
    class: { default: '' }
  },
  setup(__props: any) {

const props = __props;

const consentStore = useConsentStore();
const adLoaded = ref(false);
const adId = ref(`ad-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`);

const isNative = computed(() => Capacitor.isNativePlatform());
const shouldShowAd = computed(() => {
  return consentStore.canUseAdvertising && admobService.isEnabled();
});

const adContainerClass = computed(() => {
  const baseClasses = 'w-full flex justify-center items-center';
  return `${baseClasses} ${props.class}`;
});

const loadAd = async () => {
  if (!shouldShowAd.value || !isNative.value) {
    return;
  }

  try {
    if (props.adType === 'banner' || props.adType === 'rectangle') {
      const success = await admobService.showBannerAd(props.position);
      adLoaded.value = success;
    }
  } catch (error) {
    console.error('Failed to load ad:', error);
    adLoaded.value = false;
  }
};

const hideAd = async () => {
  if (isNative.value && adLoaded.value) {
    try {
      await admobService.hideBannerAd();
      adLoaded.value = false;
    } catch (error) {
      console.error('Failed to hide ad:', error);
    }
  }
};

// Watch for consent changes
watch(shouldShowAd, (newValue) => {
  if (newValue) {
    loadAd();
  } else {
    hideAd();
  }
});

onMounted(async () => {
  if (shouldShowAd.value) {
    // Small delay to ensure AdMob is initialized
    setTimeout(loadAd, 500);
  }
});

onUnmounted(() => {
  hideAd();
});

return (_ctx: any,_cache: any) => {
  return (shouldShowAd.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(adContainerClass.value),
        style: _normalizeStyle({ minHeight: _ctx.minHeight })
      }, [
        (!isNative.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "bg-gray-200 border-2 border-dashed border-gray-400 rounded-lg flex items-center justify-center text-gray-600",
              style: _normalizeStyle({ height: _ctx.minHeight })
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.adType.toUpperCase()) + " AD", 1),
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-xs mt-1" }, "Mobile Preview", -1))
              ])
            ], 4))
          : (isNative.value && adLoaded.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                id: `admob-${_ctx.adType}-${adId.value}`,
                class: "w-full"
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
      ], 6))
    : _createCommentVNode("", true)
}
}

})